import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAppReady)?_c(VApp,[_c(_vm.currentLayout,{tag:"component"},[_c('router-view')],1),_c(VSnackbar,{attrs:{"timeout":_vm.toast.timeout,"color":_vm.toast.color,"bottom":""},model:{value:(_vm.toast.show),callback:function ($$v) {_vm.$set(_vm.toast, "show", $$v)},expression:"toast.show"}},[_vm._v(" "+_vm._s(_vm.toast.message)+" "),(_vm.toast.timeout === 0)?_c(VBtn,{attrs:{"color":"white","text":""},on:{"click":function($event){_vm.toast.show = false}}},[_vm._v("Close")]):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }